import React from 'react'
import { connect } from 'react-redux'
import { AccessResult, TicketResult, OrderEventResult } from 'components/core'
import FlowView from 'components/core/FlowView'
import http from 'API/http'
import { ContentHeader, StaticBox, NoContentBox } from 'components/basic'
import axios from 'axios'

const CancelToken = axios.CancelToken
class Search23 extends FlowView {
  constructor (props) {
    super(props)
    this.state = {
      limit: 10,
      placeholders: ['Accesses', 'Tickets', 'Internal Reference'],
      activePage: 0,
      query: props.search.query || '',
      searchName: '',
      menu: false,
      index: props.search.index || 0,
      icon: 'fa-home',
      lastResult: 10,
      loading: false
    }
    this.timer = null
    this.cancelToken = CancelToken.source()
  }
  componentWillUnmount () {
    this.clearSearch()
  }
  componentDidMount () {
    this.setState({
      index: this.props.search.index ? this.props.search.index : 0,
      icon: this.props.search.index ? this.state.placeholders[this.props.search.index] : 'fa-home'
    })
    this.props.dispatch({
      type: 'SET_PAGE_TITLE',
      payload: 'Search'
    })
  }
  loadMore () {
    if (this.state.lastResult < this.state.limit) return
    this.setState({activePage: ++this.state.activePage, loading: true}, e => {
      this.dispatchQuery(this.props.search.query, this.state.index, true)
    })
  }
  async dispatchQuery (query, index, append) {
    this.setState({loading: true})
    let endpoints = ['2.3/accesses/search/', '2.3/tickets/search/ticket', '2.3/orderevents/search/']
    this.cancelToken.cancel()
    let cancelToken = CancelToken.source()
    this.cancelToken = cancelToken
    var endpoint = endpoints[index]
    var [err, res] = await http.get(endpoint, {search: query ,sortingBy: 'updated', sortingOrder: 'desc', limit: this.state.limit, offset: (this.state.limit * this.state.activePage)}, null, { cancelToken: cancelToken.token })
    if (err) return this.setState({loading: false})
    this.setState({lastResult: res.data.length, loading: false})
    if (append) res.data = [...this.props.search.results, ...res.data]
    this.props.dispatch({
      type: 'SET_SEARCH',
      payload: {
        query: query,
        results: res.data,
        index: index
      }
    })
  }

  handleChange (event, index) {
    var query = event.target.value
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.setState({lastResult: 10, activePage: 0}, e => this.dispatchQuery(query, index))
    }, 350)
  }

  clearSearch () {
    this.props.dispatch({
      type: 'SET_SEARCH',
      payload: {
        query: '',
        results: false,
        index: this.state.index
      }
    })
  }
  setIndex (index, icon) {
    this.setState({menu: false, index: index, icon: icon})
    this.clearSearch()
  }
  render () {
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Flow' subtitle='Search' />
        <hr />
        <div className='row'>
          <StaticBox cols={12} xs={12} sm={12} icon='search' title='Search'>
            <div className='input-group search big-search col-md-12'>
              <span className='input-group-addon' onClick={(e) => { this.setState({menu: !this.state.menu}) }}>
                <i className={'fa fa-fw ' + this.state.icon} />
                <div className={'search-index-menu ' + (this.state.menu ? '' : 'hidden')}>
                  <a title='Access' onClick={() => { this.setIndex(0, 'fa-home') }}><i className='fa fa-fw fa-home' /></a>
                  <a title='Trouble Tickets' onClick={() => { this.setIndex(1, 'fa-commenting-o') }}><i className='fa fa-fw fa-commenting-o' /></a>
                  <a title='Internal Reference' onClick={() => { this.setIndex(2, 'fa-sliders') }}><i className='fa fa-fw fa-sliders' /></a>
                </div>
              </span>
              <input
                key={this.state.index}
                ref={el => (this.searchField = el)}
                type='text'
                defaultValue={this.props.search.query}
                onChange={(e) => {
                  this.handleChange(e, this.state.index)
                }}
                className='form-control input-lg'
                placeholder={'Search ' + this.state.placeholders[this.state.index]} />
            </div>
            <div className='row'>
              <div className='col-md-12'>
                <div className='list-group flow-search-results full-search-results'>
                  {this.props.search.results && this.props.search.results.map((result, i) => {
                    if (this.state.index === 0) {
                      return <AccessResult clearSearch={e => this.clearSearch()} key={i} result={result} active={(++i === this.state.location)} />
                    } else if (this.state.index === 1) {
                      return <TicketResult clearSearch={e => this.clearSearch()} key={i} result={result} active={(++i === this.state.location)} />
                    } else if (this.state.index === 2) {
                      return <OrderEventResult clearSearch={e => this.clearSearch()} key={i} result={result} active={(++i === this.state.location)} />
                    }
                  })}
                  {!this.state.loading && this.props.search.results && !this.props.search.results.length &&
                    <NoContentBox icon='exclamation' text={'No result for ' + this.props.search.query} />
                  }
                  {this.state.loading &&
                    <NoContentBox icon='spinner fa-spin' text='Loading...' />
                  }
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-12 text-center padding-20'>
                {this.props.search.results && !!this.props.search.results.length && !(this.state.lastResult < this.state.limit) && <button onClick={e => this.loadMore()} className='btn btn-primary'>{this.state.loading ? <i className='fa fa-spin fa-spinner' /> : 'Load more results'}</button>}
              </div>
            </div>
          </StaticBox>
        </div>
      </div>
    )
  }
}
// eslint-disable-next-line
Search23 = connect(state => state.siteReducer)(Search23)
export default Search23



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/2.4/search/search.js